import { render, staticRenderFns } from "./DetallesView.vue?vue&type=template&id=7091f877&scoped=true"
import script from "./DetallesView.vue?vue&type=script&lang=js"
export * from "./DetallesView.vue?vue&type=script&lang=js"
import style0 from "./DetallesView.vue?vue&type=style&index=0&id=7091f877&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7091f877",
  null
  
)

export default component.exports